import { useDispatch } from 'react-redux';
import { clearText, setText } from 'src/modules/Redux/slices/announcer';
import { useEleven } from './useEleven';

export const useAnnouncer = () => {
    const dispatch = useDispatch();
    const { play } = useEleven();

    const announce = async (text: string) => {
        dispatch(setText(text)); // set the text that is being played
        play(text, () => {
            dispatch(clearText()); // clear the text after it is played
        });
    };

    return { announce };
};
